<script>
export default {
    name: "VitalsRepresentation",

    props: {
        showModal: Boolean,
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/2 w-11/12">
          <template v-slot:title>
            <h5 class="font-medium text-base">Vitals Graphical Representation</h5>
          </template>
          <template v-slot:modal-body>
            <div class="w-full flex flex-col p-tiny -m-3">
                <div class="flex-1 border-2 border-blue-500 rounded-t-md px-4">
                    <a href="javascript:void"><img src="/thermometer.svg" 
                        class="w-12 h-10 ml-3"></a>
                    <h5 class="font-bold text-blue-800 text-sm">Temperature</h5>
                </div>
                <div class="flex-1 border-2 border-blue-500 px-3">
                    <a href="javascript:void"><img src="/blood-pressure.svg" 
                        class="w-12 h-10 ml-3"></a>
                    <h5 class="font-bold text-blue-800 text-sm">Blood pressure</h5>
                </div>
                <div class="flex-1 border-2 border-blue-500 px-4">
                    <a href="javascript:void"><img src="/pulse-rate.svg" 
                        class="w-12 h-10 ml-3"></a>
                    <h5 class="font-bold text-blue-800 text-sm">Pulse Rate</h5>
                </div>
                <div class="flex-1 border-2 border-blue-500 rounded-b-md px-2">
                    <a href="javascript:void"><img src="/respiratory.svg" 
                        class="w-12 h-10 ml-3"></a>
                    <h5 class="font-bold text-blue-800 text-sm">Respiratory Rate</h5>
                </div>
            </div>
          </template>
          <template v-slot:modal-footer>
            <button class="btn-danger btn-sm text-sm" 
                @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
          </template>
        </tail-modal>
</template>